import { isAxiosError } from 'axios'
import type { UnknownObject } from '~/shared/interfaces'
import { isUnknownObject } from '~/shared/utils/guards'

export interface ErrorApiOptions extends ErrorOptions {
  message?: string
}

export class ErrorApi extends Error {
  readonly data: UnknownObject = {}
  readonly code: number = 0
  readonly validation: Record<string, string[]> = {}

  constructor(error: Error, options?: ErrorApiOptions) {
    super(undefined, options)

    this.message = error.message

    if (isAxiosError(error)) {
      this.code = error.status ?? 0

      const response = error.response?.data ?? {}

      if (isUnknownObject(response)) {
        let message = String(response.message ?? '')
        const validation: Record<string, string[]> = {}

        if (isUnknownObject(response.errors)) {
          Object.entries(response.errors).forEach(([key, value]) => {
            if (Array.isArray(value) && value.length) {
              validation[key] = value.map(item => String(item))
            }
          })
        }

        if (isUnknownObject(response.data) && isUnknownObject(response.data.errors)) {
          Object.entries(response.data.errors).forEach(([key, value]) => {
            if (Array.isArray(value) && value.length) {
              validation[key] = value.map(item => String(item))
              message += `${message ? '. ' : ''}${value.join('. ')}`
            }
          })
        }

        if (!message && this.code) {
          message = `Response not successful: Received status code ${this.code}.`
        }

        this.data = response
        this.validation = validation
        this.message = message || error.message
      }
    }
    if (options?.message) {
      this.message = options.message
    }
  }

  static isApiError(error: unknown): error is ErrorApi {
    return error instanceof ErrorApi
  }
}
